import { parsePhoneNumberFromString } from "libphonenumber-js"

export const createPhoneValidator = (t) => (_, value) => {
  const number = value?.number?.trim?.() || ""

  if (!number) {
    return Promise.resolve()
  }

  if (!value?.countryCode || !value?.code) {
    return Promise.reject(new Error(t("Please enter a valid phone number")))
  }

  const phoneNumber = parsePhoneNumberFromString(
    `+${value.code}${number.replace(/\D/g, "")}`,
    value.countryCode
  )

  if (!phoneNumber?.isValid()) {
    return Promise.reject(new Error(t("Please enter a valid phone number")))
  }

  return Promise.resolve()
}

export const validatePhone = (value, t) => {
  const number = value?.number?.trim?.() || ""

  if (!number) {
    return t("Phone number is required")
  }

  if (!value?.countryCode || !value?.code) {
    return t("Please enter a valid phone number")
  }

  const phoneNumber = parsePhoneNumberFromString(
    `+${value.code}${number.replace(/\D/g, "")}`,
    value.countryCode
  )

  if (!phoneNumber?.isValid()) {
    return t("Please enter a valid phone number")
  }

  return null
}
